// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-53e7c30e]::-webkit-inner-spin-button,input[data-v-53e7c30e]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}input[type=number][data-v-53e7c30e]{-moz-appearance:textfield}", ""]);
// Exports
module.exports = exports;
